import script from "./sf-virtual-table-data-row.vue?vue&type=script&setup=true&lang=js"
export * from "./sf-virtual-table-data-row.vue?vue&type=script&setup=true&lang=js"

import "./sf-virtual-table-data-row.vue?vue&type=style&index=0&id=54ff528e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54ff528e"]])

export default __exports__